// src/pages/Advertisement/ForgotPasswordAds.tsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../shared/api/axios';
import { useTranslation } from 'react-i18next';
import HighLogo from "../../HighLogo";
import logo from "../../../assets/logo.png";
import StartFooter from "../StartFooterAd";

const ForgotPasswordAds = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setMessage('');

  const normalizedEmail = email.trim().toLowerCase();

  if (!normalizedEmail) {
    setMessage(t('pleaseEnterEmail'));
    return;
  }

  try {
   await api.post('/auth/forgot-password', {
  email: normalizedEmail,
  language: i18n.language,
  flow: 'ads',
});

    sessionStorage.setItem('passwordResetFlow', 'ads');
    sessionStorage.setItem('passwordResetReturnTo', '/ad-login');

    navigate('/email-sent-ads', {
      state: {
        email: normalizedEmail,
      },
    });
  } catch (err) {
    console.error('Forgot password error:', err);
    setMessage(t('couldNotSendResetEmail'));
  }
};

 return (
       <div
      style={{
        minHeight: '100vh',
        width: '100%',
        background:
          'radial-gradient(circle at top, #020617 0, #000 40%, #020617 100%)',
        color: '#f9fafb',
        fontFamily:
          'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
        display: 'flex',
        flexDirection: 'column',
      }}
    >


 <div style={floatingLogoStyle}>
  <button
    type="button"
    onClick={() => navigate('/ads-home')}
    aria-label="Go to homepage"
    style={floatingLogoButtonStyle}
  >
    <HighLogo
      src={logo}
      style={{
        width: 190,
        display: 'block',
      }}
      padding={0}
    />
  </button>
</div>


    <main style={mainStyle}>
      <section style={forgotPanel}>
        <button type="button" onClick={() => navigate('/ad-login')} aria-label="Back" style={backBtn}>
          ‹
        </button>

        <h1 style={titleStyle}>{t("forgotPassword")}</h1>

        <p style={subtitleStyle}>
          {t("enterYourEmail") ||
            "Enter your email address and we will send you a reset link."}
        </p>

        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={fieldGroup}>
            <label style={labelStyle}>{t("email")}</label>
            <input
              type="email"
              placeholder={t("email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputModern}
              required
            />
          </div>

          <button type="submit" style={submitBtn}>
            {t("sendResetLink")}
          </button>
        </form>

        {message && <p style={messageStyle}>{message}</p>}

        <div style={legalBlock}>
          <div style={{ marginBottom: 8 }}>
            {t("legalNoticeforgotpassword", "By continuing, you agree to our policies.")}
          </div>

          <span onClick={() => navigate("/legal/privacypolicy")} style={legalLink}>
            {t("profileSetup.privacyPolicy", "Privacy Policy")}
          </span>

          {" · "}

          <span onClick={() => navigate("/legal/termsofuse")} style={legalLink}>
            {t("profileSetup.termsOfUse", "Terms of Use")}
          </span>
        </div>
      </section>
    </main>
     <StartFooter />
  </div>
);
};

export default ForgotPasswordAds;


const mainStyle: React.CSSProperties = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "42px 32px",
};

const forgotPanel: React.CSSProperties = {
  position: "relative",
  width: "100%",
  maxWidth: 440,
  borderRadius: 28,
  border: "1px solid rgba(148,163,184,0.24)",
  background: "linear-gradient(145deg, rgba(15,23,42,0.94), rgba(2,6,23,0.98))",
  boxShadow: "0 30px 80px rgba(0,0,0,0.75)",
  padding: "34px 42px 38px",
};

const backBtn: React.CSSProperties = {
  position: "absolute",
  top: 4,
  left: -2,
  width: 42,
  height: 42,
  borderRadius: "50%",
  background: "transparent",
  border: "none",
  color: "#c2ccd8",
  cursor: "pointer",
  fontSize: 30,
  lineHeight: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const titleStyle: React.CSSProperties = {
  fontSize: 32,
  lineHeight: 1.05,
  margin: "14px 0 12px 0",
  color: "#f8fafc",
  letterSpacing: -0.8,
  textAlign: "center",
};

const subtitleStyle: React.CSSProperties = {
  margin: "0 auto 26px",
  color: "#94a3b8",
  fontSize: 13,
  lineHeight: 1.5,
  maxWidth: 330,
  textAlign: "center",
};

const formStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
};

const fieldGroup: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 6,
};

const labelStyle: React.CSSProperties = {
  fontSize: 12,
  color: "#cbd5e1",
  fontWeight: 600,
  marginLeft: 5,
};

const inputModern: React.CSSProperties = {
  width: "100%",
  height: 50,
  padding: "0 18px",
  borderRadius: 16,
  border: "1px solid rgba(148,163,184,0.25)",
  background: "rgba(15,23,42,0.45)",
  color: "#f8fafc",
  fontSize: 16,
  outline: "none",
  boxSizing: "border-box",
  boxShadow: "inset 0 1px 0 rgba(255,255,255,0.03)",
};

const submitBtn: React.CSSProperties = {
  marginTop: 8,
  padding: "12px 18px",
  borderRadius: 999,
  border: "1px solid rgba(250,250,250,0.22)",
  background: "linear-gradient(135deg, rgba(212,175,55,0.98), rgba(250,250,210,0.92))",
  color: "#111827",
  fontWeight: 800,
  fontSize: 15,
  cursor: "pointer",
};

const messageStyle: React.CSSProperties = {
  color: "#fca5a5",
  marginTop: 18,
  textAlign: "center",
  fontSize: 13,
};

const legalBlock: React.CSSProperties = {
  marginTop: 24,
  textAlign: "center",
  fontSize: 10.5,
  color: "#64748b",
  lineHeight: 1.5,
};

const legalLink: React.CSSProperties = {
  cursor: "pointer",
  color: "#94a3b8",
};


const floatingLogoStyle: React.CSSProperties = {
  width: "100%",
  padding: "28px 20px 0",
  boxSizing: "border-box",
};

const floatingLogoButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  padding: 0,
  margin: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
};
